import { render } from "./IconUncertain.vue?vue&type=template&id=cb879fc2&ts=true"
import script from "./IconUncertain.vue?vue&type=script&lang=ts"
export * from "./IconUncertain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__